import { Editor } from '@tiptap/core';
import { AskAiCommandName, AskAiCommandStorage } from '../command';
import { AskAiCommand as AskAiCommandEnum } from '../types';

export const InProgressStorageManager = (editor: Editor) => {
  const storage = editor.storage[AskAiCommandName] as AskAiCommandStorage;
  const getInProgressCommands = () => {
    return storage.inProgressCommandSet.get(editor) || [];
  };
  const addInProgressCommand = (command: AskAiCommandEnum) => {
    storage.inProgressCommandSet.set(editor, [
      ...getInProgressCommands(),
      command,
    ]);
  };
  const removeInProgressCommand = (command: AskAiCommandEnum) => {
    storage.inProgressCommandSet.set(editor, [
      ...getInProgressCommands().filter((c) => c !== command),
    ]);
  };

  return {
    getInProgressCommands,
    addInProgressCommand,
    removeInProgressCommand,
  };
};
